/**
 * Vendored from AudioCN (https://github.com/audiocn/ui), hand-copied at
 * commit 42f863ec333c6912c421d1e9d6d7ce7850ce2680.
 * Source file: hooks/use-frame-source.ts
 * License: MIT, Copyright (c) 2026 OrcDev. See components/ui/audiocn/LICENSE.md.
 * Local changes:
 *   - import path now points at lib/audiocn/types
 */
"use client";

import { useEffect, useEffectEvent } from "react";

import type { FrameSource } from "@/lib/audiocn/types";

export interface UseFrameSourceOptions {
  /** Pause the subscription without unmounting. Default true. */
  enabled?: boolean;
}

/**
 * Subscribes `onFrame` to a frame source. The callback can change on every
 * render without resubscribing.
 */
export const useFrameSource = <T>(
  source: FrameSource<T> | null | undefined,
  onFrame: (frame: T) => void,
  { enabled = true }: UseFrameSourceOptions = {}
): void => {
  const handleFrame = useEffectEvent(onFrame);

  useEffect(() => {
    if (!(source && enabled)) {
      return;
    }
    return source.subscribe((frame) => {
      handleFrame(frame);
    });
  }, [source, enabled]);
};
